import {
	FormUiSchema,
	JsonSchemaDefinition,
	referenceOptions
} from "../runtime";

/** Display labels belong to one form session and are shared with its row editors. */
export type ReferenceLabelStore = Map<string, Map<unknown, string>>;

export function referenceLabelKey(schema: JsonSchemaDefinition, ui: FormUiSchema): string {
	return JSON.stringify([schema.format, referenceOptions(schema, ui)]);
}
